module.exports = __webpack_public_path__ + "static/rakshasha-8fc2621012e4532dc1210cfd7b92acb4.jpg";